import React from 'react';
import CensorBar from './CensorBar';

// Two-pane before/after portrait component. DESIGN.md §6.1 PortraitComparison.
//
// Props:
//   before: { imageUrl, score, dateLabel, alt }
//   after:  { imageUrl, score, dateLabel, alt }
//   showArrow: bool   between-pane arrow on desktop
//   stackOnMobile: bool  vertical stack at <420px instead of side-by-side
const PortraitComparison = ({
  before,
  after,
  showArrow = true,
  stackOnMobile = false,
  className = '',
}) => {
  const layout = stackOnMobile
    ? 'flex flex-col xs:flex-row items-stretch gap-3 sm:gap-6'
    : 'flex items-stretch gap-3 sm:gap-6';

  return (
    <div className={[layout, className].filter(Boolean).join(' ')}>
      <Pane data={before} label="BEFORE" />
      {showArrow && (
        <div className="hidden sm:flex items-center justify-center">
          <ArrowGlyph />
        </div>
      )}
      <Pane data={after} label="AFTER" />
    </div>
  );
};

const Pane = ({ data, label }) => {
  if (!data) return null;
  return (
    <div className="flex-1 min-w-0 flex flex-col gap-2">
      <div
        className="font-display uppercase tracking-[0.12em] text-bone-dim"
        style={{ fontSize: 10 }}
      >
        {label}{data.dateLabel ? ` — ${data.dateLabel}` : ''}
      </div>
      <div className="relative aspect-[3/4] overflow-hidden rounded-panel bg-vein border border-hairline-soft shadow-card-lift">
        {data.imageUrl ? (
          <img
            src={data.imageUrl}
            alt={data.alt || ''}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-vein" role="img" aria-label={data.alt || ''} />
        )}
        {/* Bottom scrim — keeps any overlaid labels legible, adds depth */}
        <div
          className="absolute inset-x-0 bottom-0 h-1/4 pointer-events-none"
          style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.5), transparent)' }}
          aria-hidden="true"
        />
        {data.score != null && data.score !== '' && (
          <div className="absolute left-0 right-0 top-[42%] flex justify-center px-2">
            <CensorBar mode="SCORE" value={data.score} size="lg" />
          </div>
        )}
      </div>
    </div>
  );
};

const ArrowGlyph = () => (
  <div className="w-8 h-8 rounded-full bg-vein flex items-center justify-center">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M2 7 L12 7 M8 3 L12 7 L8 11" stroke="currentColor" strokeWidth="1.2" className="text-bone-pure" fill="none" />
    </svg>
  </div>
);

export default PortraitComparison;
